(function ( ) {

    let navToggle = document.getElementById('nav-toggle'),
            siteNavigation = document.getElementById('site-navigation')


    navToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        document.body.classList.toggle('menu-open')
        var x = 'true' == navToggle.getAttribute('aria-expanded') ? 'false' : 'true'
        navToggle.setAttribute('aria-expanded', x)
    })

    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', function (e) {
        if (!siteNavigation.contains(e.target)) {
            document.body.classList.remove('menu-toggled')
            navToggle.setAttribute('aria-expanded', 'false')
        }
    });


})()
